import React from 'react'

import General from '../utils/General'
import ScriptCache from '../utils/ScriptCache'

import '../assets/css/metronic/pages/error/error-6.css'
import '../assets/css/metronic/style.bundle.css'

const IMG_NOT_FOUND = require("../assets/img/NotFound.jpg")

export default class NotFound extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      website: props.website,
      loading: true,
      underConstruction: props.underConstruction
    }
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  _loadJs(){
    ScriptCache.loadDefaults()
    setTimeout(() => {
      General.updateAll()
    }, 1000)
  }


  render(){
    return (
      <div className="css-metronic">

        <div className="kt-grid kt-grid--ver kt-grid--root cover-fullscreen">
          <div className="kt-grid__item kt-grid__item--fluid kt-grid  kt-error-v6">

            <div className="kt-error_container">
              <div className="kt-error_subtitle kt-font-light">
                <h3 style={{ paddingTop: "15%", fontWeight: 500, fontSize: '1.75rem' }}>
                  Please Publish Your Site To Go Live!
                </h3>
              </div>
            </div>

          </div>
        </div>

      </div>
    )
  }
}
